<template>
    <div>
        <anchor
            v-if="doc.link"
            :field="doc.link"
            class="block overflow-hidden"
        >
            <asset
                :url="doc.image"
                :w="w"
                :h="h"
                fit="crop_focal"
                :style="'max-width: ' + max_width + '; display: inline-block;'"
            />
        </anchor>
        <asset
            v-else
            :url="doc.image"
            :w="w"
            :h="h"
            fit="crop_focal"
            class="inline-block"
        />
    </div>
</template>

<script>
export default {
    props: ["doc"],

    data() {
        return {
            w: "800",
            h: "auto"
        };
    },

    methods: {
        update() {
            this.w = this.doc.max_width * 8 || 800;
            this.h = this.doc.keep_ratio
                ? "auto"
                : (this.w * this.doc.ratio) / 100 || "auto";
            this.max_width = this.doc.max_width + "%";
        }
    },

    created() {
        this.update();
    }
};
</script>


// WEBPACK FOOTER //
// src/components/TextImage.vue